<div class="fs-2" mat-dialog-title>
    Bienvenue sur LyBox
<!--    <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle" /><b>Thomas</b> de LyBox<br/>-->
    <i *ngIf="step == 'step8'" class="fa fa-close mt-1" (click)="onYesClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <div class="step1 step" [hidden]="step != 'step1'">
        Bonjour et bienvenue,<br/>
        <br/>
        Vous êtes au bon endroit pour faire votre prochain <b>investissement rentable !</b><br/>
        <br/>
        Je suis Thomas, cofondateur de Lybox et je vais vous <b>accompagner dans vos premiers pas avec l’application.</b><br/>
        <br/>
        LyBox va vous permettre <b>d'accélérer, optimiser et sécuriser</b> vos prochains investissements immobiliers.<br/>
        <br/>
        <b class="text-primary text-center d-block">
            Que vous soyez novice, expérimenté ou même professionnel de l'immobilier :<br/> LyBox est fait pour vous !
        </b>
        <br/>
        Pour améliorer votre expérience sur le site, aidez-nous à mieux vous connaître.<br/>
        <br/>
        <div class="text-center">
            <button type="button" (click)="step = 'step2'" class="btn btn-primary ps-5 pe-5">
                <i class="fa fa-play me-3" aria-hidden="true"></i> Commencer
            </button>
        </div>
    </div>
    <div class="step2 step" [hidden]="step != 'step2'">
        <b class="subtitle">Pour commencer, quel est votre profil d'investisseur ?</b>
        <div class="main-card">
            <div class="type-menu-check mx-auto mt-4 mb-4">
                <a class="type-option" [class.active]="profil == 'debutant'"
                   (click)="choose('profil', 'debutant', 'step3')">
                    <i class="icon icon-profil_debutant"></i>
                    <span class="type-option-label">Investisseur débutant</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="profil == 'expert'"
                   (click)="choose('profil', 'expert', 'step3')">
                    <i class="icon icon-profil_expert"></i>
                    <span class="type-option-label">Investisseur confirmé</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="profil == 'pro'"
                   (click)="choose('profil', 'pro', 'step3')">
                    <i class="icon icon-profil_pro"></i>
                    <span class="type-option-label">Professionnel de l'immobilier</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
            </div>
            <div class="text-center">
                <button type="button" [disabled]="profil == ''" (click)="step = 'step3'" class="btn btn-primary ps-5 pe-5">
                    <i class="fa fa-arrow-right me-3" aria-hidden="true"></i> Suivant
                </button>
            </div>
        </div>
    </div>
    <div class="step3 step" [hidden]="step != 'step3'">
        <b *ngIf="profil == 'pro'" class="subtitle">Quel est votre cœur de métier ?</b>
        <b *ngIf="profil != 'pro'" class="subtitle">Quel type d'opération souhaitez-vous réaliser ?</b>
        <div class="main-card">
            <div class="type-menu-check mx-auto mt-4 mb-4">
                <a class="type-option" [class.active]="op == 'locatif'"
                   (click)="choose('op', 'locatif', 'step4')">
                    <i class="icon icon-op_locatif"></i>
                    <span class="type-option-label">Investissement locatif</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" *ngIf="profil == 'pro'" [class.active]="op == 'chasse'"
                   (click)="choose('op', 'chasse', 'step4')">
                    <i class="icon icon-op_chasse"></i>
                    <span class="type-option-label">Chasse immobilière</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" *ngIf="profil == 'pro'" [class.active]="op == 'agence'"
                   (click)="choose('op', 'agence', 'step4')">
                    <i class="icon icon-op_agence"></i>
                    <span class="type-option-label">Agence immobilière</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" *ngIf="profil == 'pro'" [class.active]="op == 'gestion_patrimoine'"
                   (click)="choose('op', 'gestion_patrimoine', 'step4')">
                    <i class="icon icon-op_gestion_patrimoine"></i>
                    <span class="type-option-label">Gestion de patrimoine</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="op == 'mdb'"
                   (click)="choose('op', 'mdb', 'step4')">
                    <i class="icon icon-op_mdb"></i>
                    <span class="type-option-label">Achat/revente — Marchand de biens</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" *ngIf="profil == 'pro'" [class.active]="op == 'promotion'"
                   (click)="choose('op', 'promotion', 'step4')">
                    <i class="icon icon-op_promotion"></i>
                    <span class="type-option-label">Promotion immobilière</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" *ngIf="profil != 'pro'" [class.active]="op == 'rp'"
                   (click)="choose('op', 'rp', 'step4')">
                    <i class="icon icon-op_rp"></i>
                    <span class="type-option-label">Résidence principale ou secondaire</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="op == 'other'"
                   (click)="choose('op', 'other', 'step4')">
                    <i class="icon icon-empty"></i>
                    <span class="type-option-label">Autre</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
            </div>
            <div class="text-center">
                <button type="button" [disabled]="op == ''" (click)="step = 'step4'" class="btn btn-primary ps-5 pe-5">
                    <i class="fa fa-arrow-right me-3" aria-hidden="true"></i> Suivant
                </button>
            </div>
        </div>
    </div>

    <div class="step4 step" [hidden]="step != 'step4'">
        <ng-container *ngIf="profil == 'pro'">
            <b class="subtitle">Quelle est la taille de votre entreprise ?</b>
            <div class="main-card">
            <div class="type-menu-check mx-auto mt-4 mb-4">
                <a class="type-option" [class.active]="pro_size == '1'"
                   (click)="choose('pro_size', '1', 'step5')">
                    <i class="icon icon-pro_size-1"></i>
                    <span class="type-option-label">Entre 1 et 3 personnes</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="pro_size == '4'"
                   (click)="choose('pro_size', '4', 'step5')">
                    <i class="icon icon-pro_size-4"></i>
                    <span class="type-option-label">Entre 4 et 10 personnes</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="pro_size == '10'"
                   (click)="choose('pro_size', '10', 'step5')">
                    <i class="icon icon-pro_size-10"></i>
                    <span class="type-option-label">Plus de 10 personnes</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
            </div>
            </div>
        </ng-container>
        <ng-container *ngIf="profil != 'pro'">
            <b class="subtitle">Quelle est la taille de votre patrimoine actuel (hors résidence principale) ?</b>
            <div class="main-card">
            <div class="type-menu-check mx-auto mt-4 mb-4">
                <a class="type-option" [class.active]="patrimoine_size == '0'"
                   (click)="choose('patrimoine_size', '0', 'step5')">
                    <i class="icon icon-patrimoine_size-0"></i>
                    <span class="type-option-label">Aucun bien</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="patrimoine_size == '1'"
                   (click)="choose('patrimoine_size', '1', 'step5')">
                    <i class="icon icon-patrimoine_size-1"></i>
                    <span class="type-option-label">Entre 1 et 3 biens</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="patrimoine_size == '3'"
                   (click)="choose('patrimoine_size', '3', 'step5')">
                    <i class="icon icon-patrimoine_size-3"></i>
                    <span class="type-option-label">Plus de 3 biens</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
            </div>
            </div>
        </ng-container>
        <div class="text-center">
            <button type="button" [disabled]="pro_size == '' && patrimoine_size == ''" (click)="step = 'step5'" class="btn btn-primary ps-5 pe-5">
                <i class="fa fa-arrow-right me-3" aria-hidden="true"></i> Suivant
            </button>
        </div>
    </div>
    <div class="step5 step" [hidden]="step != 'step5'">
        <b class="subtitle">Quel est votre secteur de recherche ?</b>
        <div class="main-card">
            <div class="type-menu-check mx-auto mt-4 mb-4">
                <a class="type-option" [class.active]="zone == 'home'"
                   (click)="choose('zone', 'home', 'step6')">
                    <i class="icon icon-zone_home"></i>
                    <span class="type-option-label">Autour de chez moi</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="zone == 'district'"
                   (click)="choose('zone', 'district', 'step6')">
                    <i class="icon icon-zone_disctrict"></i>
                    <span class="type-option-label">Un département / Région</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="zone == 'france'"
                   (click)="choose('zone', 'france', 'step6')">
                    <i class="icon icon-zone_france"></i>
                    <span class="type-option-label">France entière</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
            </div>
            <div class="text-center">
                <button type="button" [disabled]="zone == ''" (click)="step = 'step6'" class="btn btn-primary ps-5 pe-5">
                    <i class="fa fa-arrow-right me-3" aria-hidden="true"></i> Suivant
                </button>
            </div>
        </div>
    </div>
    <div class="step6 step" [hidden]="step != 'step6'">
        <b class="subtitle">Comment avez-vous connu LyBox ?</b>
        <div class="main-card">
            <div class="type-menu-check mx-auto mt-4 mb-4">
                <a class="type-option" [class.active]="source == 'Facebook'"
                   (click)="choose('source', 'Facebook', 'step7')">
                    <i class="icon icon-source_facebook"></i>
                    <span class="type-option-label">Facebook</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Twitter'"
                   (click)="choose('source', 'Twitter', 'step7')">
                    <i class="icon icon-source_twitter"></i>
                    <span class="type-option-label">Twitter</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Instagram'"
                   (click)="choose('source', 'Instagram', 'step7')">
                    <i class="icon icon-source_instagram"></i>
                    <span class="type-option-label">Instagram</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Tik Tok'"
                   (click)="choose('source', 'Tik Tok', 'step7')">
                    <i class="icon icon-source_tiktok"></i>
                    <span class="type-option-label">Tik Tok</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Youtube'"
                   (click)="choose('source', 'Youtube', 'step7')">
                    <i class="icon icon-source_youtube"></i>
                    <span class="type-option-label">Youtube</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Linked\'In'"
                   (click)="choose('source', 'Linked\'In', 'step7')">
                    <i class="icon icon-source_linkedin"></i>
                    <span class="type-option-label">Linked'In</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Recherche Google'"
                   (click)="choose('source', 'Recherche Google', 'step7')">
                    <i class="icon icon-source_google"></i>
                    <span class="type-option-label">Recherche Google</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Newletter'"
                   (click)="choose('source', 'Newletter', 'step7')">
                    <i class="icon icon-source_newsletter"></i>
                    <span class="type-option-label">Newsletter</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Bouche à oreille'"
                   (click)="choose('source', 'Bouche à oreille', 'step7')">
                    <i class="icon icon-source_friends"></i>
                    <span class="type-option-label">Bouche à oreille</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Salon immobilier'"
                   (click)="choose('source', 'Salon immobilier', 'step7')">
                    <i class="icon icon-source_salon"></i>
                    <span class="type-option-label">Salon immobilier</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Podcast'"
                   (click)="choose('source', 'Podcast', 'step7')">
                    <i class="icon icon-source_podcast"></i>
                    <span class="type-option-label">Podcast</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Partenaire / Formateur'"
                   (click)="choose('source', 'Partenaire / Formateur', 'step7')">
                    <i class="icon icon-source_partner"></i>
                    <span class="type-option-label">Partenaire / Formateur</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Presse'"
                   (click)="choose('source', 'Presse', 'step7')">
                    <i class="icon icon-source_presse"></i>
                    <span class="type-option-label">Presse</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
                <a class="type-option" [class.active]="source == 'Other'"
                   (click)="choose('source', 'Other', 'step7')">
                    <i class="icon icon-empty"></i>
                    <span class="type-option-label">Autre</span>
                    <span class="check"><i class="fa fa-check"></i></span>
                </a>
            </div>
            <div class="text-center">
                <button type="button" [disabled]="source == ''" (click)="step = 'step7'" class="btn btn-primary ps-5 pe-5">
                    <i class="fa fa-arrow-right me-3" aria-hidden="true"></i> Suivant
                </button>
            </div>
        </div>
    </div>

    <div class="step7 step" [hidden]="step != 'step7'">
        <b class="subtitle">Pour finir, quel est votre âge ?</b>
        <div class="main-card mt-4 mb-4" style="max-width: 300px;">
            <mat-form-field>
                <mat-label>Âge</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="age">
                <span matSuffix>ans</span>
            </mat-form-field>
        </div>

        <div class="text-center">
            <button type="button" [disabled]="age == ''" (click)="step = 'step8'" class="btn btn-primary hide-mobile ps-5 pe-5">
                <i class="fa fa-check me-3" aria-hidden="true"></i> Terminer
            </button>
            <button type="button" [disabled]="age == ''" (click)="onNoClick()" class="btn btn-primary visible-mobile ps-5 pe-5">
                <i class="fa fa-check me-3" aria-hidden="true"></i> Terminer
            </button>
        </div>
    </div>

    <div class="step8 step" *ngIf="step == 'step8'">
        <iframe width="100%" height="456" class="mb-3" src="https://www.youtube.com/embed/FxmZ48Yr-y8?autoplay=1" title="Bienvenue sur lybox" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
<!--        Nous avons mis en place une <b>visite guidée</b> pour vous aider à prendre en main l’application LyBox.<br/>-->
<!--        <br/>-->
<!--        Cette visite vous permet de découvrir <b>les différentes fonctionnalités de LyBox</b>.<br/>-->
<!--        <br/>-->
<!--        Si vous ne connaissez pas encore toutes les fonctionnalités de l’application, alors je vous conseille de faire la visite.<br/>-->
<!--        <br/>-->
<!--        Si vous avez un doute, un petit tour rapide devrait <b>vous aider dans vos recherches</b> 🙂<br/>-->
<!--        <br/>-->
<!--        <b>Regardons ensemble la visite guidée de l’application</b><br/>-->
<!--        <br/>-->
        <div class="text-center">
            <button (click)="onYesClick()" type="button" class="btn btn-primary">
                <i class="fa fa-play me-3" aria-hidden="true"></i> Commencer
            </button>
        </div>
    </div>
</div>
